import { render, staticRenderFns } from "./EditGender.vue?vue&type=template&id=a0fa5920&scoped=true"
import script from "./EditGender.vue?vue&type=script&lang=js"
export * from "./EditGender.vue?vue&type=script&lang=js"
import style0 from "./EditGender.vue?vue&type=style&index=0&id=a0fa5920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fa5920",
  null
  
)

export default component.exports